import {
  useContext,
  useRef,
  useEffect,
  createRef
} from 'react';

import { RecaptchaLibContext, RecaptchaLibDispatchContext } from '../context/context';
import { RecaptchaLibToken } from '../types/types';
import executeV3 from '../functions/executeV3';

export interface RecaptchaLibV3Props {
  action?: string,
  callback: (token: RecaptchaLibToken) => void,
}

function RecaptchaLibV3({ action = 'default', callback }: RecaptchaLibV3Props) {
  const { loaded, scoreBasedSiteKey } = useContext(RecaptchaLibContext);
  const dispatchContext = useContext(RecaptchaLibDispatchContext);

  const elementRef = createRef<HTMLDivElement>();
  const callbackRef = useRef<((token: RecaptchaLibToken) => void) | undefined>(undefined);
  callbackRef.current = callback;

  useEffect(() => {
    if (!loaded || !scoreBasedSiteKey) {
      return;
    }

    dispatchContext({ scoreBasedToken: null });
    void executeV3(scoreBasedSiteKey, action).then((newToken) => {
      dispatchContext({ scoreBasedToken: newToken });
      if (callbackRef.current) {
        callbackRef.current(newToken);
      }
    });
  }, [loaded, scoreBasedSiteKey, action, dispatchContext]);

  return (
    <div ref={elementRef} />
  );
}

export default RecaptchaLibV3;
